'use client';
import { useState, useLayoutEffect } from 'react';
import useWindowSize from './use-window-size';

const useMobile = (breakpoint = 768) => {
  const { width } = useWindowSize();
  const [isMobile, setMobile] = useState<boolean>(false);  // starts as null to indicate no initial assumption

  useLayoutEffect(() => {
    if (width !== undefined) {
      setMobile(width <= breakpoint);
    }
  }, [width, breakpoint]);

  return isMobile;
};

export default useMobile;